import { useEffect, useState } from "react";
import StatusCard from "../../StatusCard/StatusCard";
import { worklistPreogressStatus } from "../../../services/managerService";
const WorkListHeader = ({ query }) => {
  const [progressStat, setPreogressStata] = useState();

  useEffect(() => {
    fetchRecord();
  }, [query]);

  const fetchRecord = async () => {
    const response = await worklistPreogressStatus();
    setPreogressStata(response);
  };

  return (
    <div className="row gy-8 g-xl-10">
      <div className="col-xxl-7 col-xl-7 col-lg-9 col-md-12 col-sm-12 col-12">
        {(localStorage.getItem("Role") === "Manager" ||
          localStorage.getItem("Role") === "Team Lead") && (
          <div className="separator separator-dotted separator-content border-dark my-4 mb-6 home-separator">
            <span className="h4 d-flex">
              <span className="bullet bullet-dot bg-grey me-2 h-7px w-7px mt-2" />{" "}
              Status
            </span>
          </div>
        )}
        <div className="row">
          {(localStorage.getItem("Role") === "Manager" ||
            localStorage.getItem("Role") === "Team Lead") && (
            <div className="col-sm-6 col-6 col-xl-4 col-md-4 mb-5 mb-xl-10">
              <StatusCard
                title={"Open"}
                colorChange={
                  "fw-semibold fs-3x text-warning text-center m-0 p-0"
                }
                picture1={"../assets/media/svg/illustrations/easy/2.svg"}
                picture2={"../assets/media/svg/illustrations/easy/2-dark.svg"}
                pic1WidthChange={"theme-light-show w-125px h-110px"}
                pic2WidthChange={"theme-dark-show w-150px"}
                data={progressStat?.openStatusWorklistsCount}
              />
            </div>
          )}
          {(localStorage.getItem("Role") === "Manager" ||
            localStorage.getItem("Role") === "Team Lead") && (
            <div className="col-sm-6 col-6 col-xl-4 col-md-4 mb-5 mb-xl-10">
              <StatusCard
                title={"In Progress"}
                colorChange={"fw-semibold fs-3x text-info text-center m-0 p-0"}
                picture1={"../assets/media/svg/illustrations/easy/4.svg"}
                picture2={"../assets/media/svg/illustrations/easy/1-dark.svg"}
                pic1WidthChange={"theme-light-show w-125px h-100px"}
                pic2WidthChange={"theme-dark-show w-125px"}
                data={progressStat?.inProgressStatusWorklistsCount}
              />
            </div>
          )}
          {(localStorage.getItem("Role") === "Manager" ||
            localStorage.getItem("Role") === "Team Lead") && (
            <div className="col-sm-6 col-6 col-xl-4 col-md-4 mb-5 mb-xl-10">
              <StatusCard
                title={"Closed"}
                colorChange={
                  "fw-semibold fs-3x text-success text-center m-0 p-0"
                }
                picture1={"../assets/media/svg/illustrations/easy/1.svg"}
                picture2={"../assets/media/svg/illustrations/easy/1-dark.svg"}
                pic1WidthChange={"theme-light-show w-125px h-100px"}
                pic2WidthChange={"theme-dark-show w-125px"}
                data={progressStat?.closedStatusWorklistsCount}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default WorkListHeader;
